export default __webpack_public_path__ + "static/media/pediatrics.0266d7dc.png";